export const EVENT_TYPES = [
  { v: "regular", l: "Reguläre Vorstellung", icon: "🎬", color: "#D4AF37" },
  { v: "marvel_night", l: "Marvel Night", icon: "🍿", color: "#D4213B" },
  { v: "hp_weekend", l: "Harry Potter Wochenende", icon: "🧙", color: "#8B4513" },
  { v: "sw_marathon", l: "Star Wars Marathon", icon: "🚀", color: "#FFE81F" },
  { v: "horror_night", l: "Horror Night", icon: "👻", color: "#5B1319" },
  { v: "weihnachtskino", l: "Weihnachtskino", icon: "🎄", color: "#2E7D32" },
  { v: "disney_family", l: "Disney Family Day", icon: "👨‍👩‍👧", color: "#4A90E2" },
  { v: "gaming_night", l: "Gaming Night", icon: "🎮", color: "#7B2CBF" },
];

export const eventType = (v) => EVENT_TYPES.find((e) => e.v === v) || EVENT_TYPES[0];

export const CLUB_TIERS = [
  { v: "bronze", l: "Bronze", color: "#8C6A2F", min: 0 },
  { v: "silver", l: "Silver", color: "#B8B8B8", min: 10 },
  { v: "vip", l: "VIP", color: "#5B1319", min: 20 },
  { v: "gold", l: "Gold Member", color: "#D4AF37", min: 50 },
];
export const tierOf = (visits) => {
  return [...CLUB_TIERS].reverse().find((t) => visits >= t.min) || CLUB_TIERS[0];
};
